import { createTheme } from '@mui/material/styles';
import COLOR from 'utils/constants/color';

export const THEME = createTheme({
    spacing: (factor) => `${8 * factor}px`,
    palette: {
        primary: {
            main: COLOR.indigo400,
        },
        secondary: {
            main: COLOR.green100,
        },
    },
    shape: {
        borderRadius: 4,
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
});